module.exports = __webpack_public_path__ + "static/media/dashIcon.58ef19c1.svg";